import { render } from "./GroupInfoModal.vue?vue&type=template&id=59aeff2a&scoped=true"
import script from "./GroupInfoModal.vue?vue&type=script&lang=js"
export * from "./GroupInfoModal.vue?vue&type=script&lang=js"

import "./GroupInfoModal.vue?vue&type=style&index=0&id=59aeff2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59aeff2a"]])

export default __exports__